export const messages_ro = {
    nameEmpty: "Câmpul de nume nu poate fi gol.",
    emailEmpty: "Câmpul adresei de e-mail nu poate fi gol.",
    emailNotValid: "Adresa de e-mail nu este validă, vă rugăm să introduceți o adresă de e-mail corectă.",
    locationEmpty: "Câmpul locației nu poate fi gol.",
    interests: "Select 3 area of interest.",
    profileSaved: "Detaliile profilului au fost salvate.",
    profilePic: "Poza de profil a fost salvată.",
    addToFavorites:"A fost adăugat cu succes la favoritele dvs.",
    removeFromFavorites:"A fost eliminat cu succes din favoritele dvs."
};


// WEBPACK FOOTER //
// ./src/constants/messages_ro.js